'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'user-bounty-hunter';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2bf';
var svgPathData = ['M16 512l128 0 4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l4.7 4.7 128 0c-8.8 0-16-7.2-16-16 0-61.9-50.1-112-112-112l-160 0c-61.9 0-112 50.1-112 112 0 8.8-7.2 16-16 16zM96.4 265.5l60.2 12c-7.9-30.1-28.9-54.9-56.6-67.8l-3.6 55.8zm10-137.5l235.2 0C330.4 72.9 281.7 32 224 32S117.6 72.9 106.4 128zm185 149.6l60.2-12-3.6-55.8c-27.7 12.9-48.7 37.7-56.6 67.8z', 'M80 0C71.2 0 64 7.2 64 16l0 248c0 1 .1 2 .3 3l-.2 3.5c-.8 12 7.5 22.7 19.2 25.1l114.6 22.9c16.2 3.2 36.1 3.2 52.3 0l114.6-22.9c11.8-2.4 20-13.1 19.2-25.1l-8.3-128.2C370.5 62.2 304.1 0 224 0 170.5 0 123.1 27.7 96 70l0-38c8.8 0 16-7.2 16-16S104.8 0 96 0L80 0zm22.2 176.1l1-16.1 104.8 0 0 127.7c-1.3-.2-2.6-.4-3.9-.7l-13.5-2.7c-7.3-50.2-42-91.5-88.4-108.3zM100 209.7c27.7 12.9 48.7 37.7 56.6 67.8l-60.2-12 3.6-55.8zm140 78l0-127.7 104.8 0 1 16.1c-46.4 16.8-81.1 58.1-88.4 108.3l-13.5 2.7c-1.3 .2-2.5 .5-3.9 .7zM341.6 128l-235.2 0C117.6 72.9 166.3 32 224 32s106.4 40.9 117.6 96zm6.4 81.7l3.6 55.8-60.2 12c7.9-30.1 28.9-54.9 56.6-67.8zM144 384l160 0c61.9 0 112 50.1 112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-79.5-64.5-144-144-144l-160 0c-79.5 0-144 64.5-144 144 0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9 50.1-112 112-112zm68.7 36.7l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserBountyHunter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;